import { render, staticRenderFns } from "./UserAuthorizationByUserCall.vue?vue&type=template&id=22d18420&"
import script from "./UserAuthorizationByUserCall.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationByUserCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d18420')) {
      api.createRecord('22d18420', component.options)
    } else {
      api.reload('22d18420', component.options)
    }
    module.hot.accept("./UserAuthorizationByUserCall.vue?vue&type=template&id=22d18420&", function () {
      api.rerender('22d18420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/UserAuthorization/components/UserAuthorizationByUserCall.vue"
export default component.exports